import { aiInRecruitingWhyChooseSectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingWhyChooseSection.module.css'

const icons: Record<string, JSX.Element> = {
  Scoring: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 6.875C17.8985 6.875 19.4375 5.33598 19.4375 3.4375C19.4375 1.53902 17.8985 0 16 0C14.1015 0 12.5625 1.53902 12.5625 3.4375C12.5625 5.33598 14.1015 6.875 16 6.875Z"
        fill="#0F0F0F"
      />
      <path
        d="M9.81831 25.9355C8.848 26.9743 7.46775 27.6255 5.9375 27.6255C4.40725 27.6255 3.027 26.9743 2.05669 25.9355C0.816313 26.7797 0 28.2027 0 29.813V31.063C0 31.5807 0.41975 32.0005 0.9375 32.0005H10.9375C11.4552 32.0005 11.875 31.5807 11.875 31.063V29.813C11.875 28.2027 11.0587 26.7797 9.81831 25.9355Z"
        fill="#0F0F0F"
      />
      <path
        d="M29.9433 25.9355C28.973 26.9743 27.5928 27.6255 26.0625 27.6255C24.5322 27.6255 23.152 26.9743 22.1817 25.9355C20.9413 26.7797 20.125 28.2027 20.125 29.813V31.063C20.125 31.5807 20.5447 32.0005 21.0625 32.0005H31.0625C31.5802 32.0005 32 31.5807 32 31.063V29.813C32 28.2027 31.1837 26.7797 29.9433 25.9355Z"
        fill="#0F0F0F"
      />
      <path
        d="M22.6701 22.8661C22.9355 24.4994 24.3554 25.7505 26.0625 25.7505C27.9579 25.7505 29.5 24.2084 29.5 22.313C29.5 20.4175 27.9579 18.8755 26.0625 18.8755C24.6421 18.8755 23.4202 19.7415 22.8969 20.9732L18.8097 19.7039C18.7647 18.5292 17.996 17.5372 16.9375 17.1617V13.1255H21C21.5177 13.1255 21.9375 12.7057 21.9375 12.188V10.938C21.9375 9.32773 21.1212 7.90473 19.8808 7.06055C18.9105 8.0993 17.5302 8.75048 16 8.75048C14.4698 8.75048 13.0895 8.0993 12.1192 7.06055C10.8788 7.90473 10.0625 9.32773 10.0625 10.938V12.188C10.0625 12.7057 10.4823 13.1255 11 13.1255H15.0625V17.1617C14.004 17.5372 13.2354 18.5291 13.1903 19.7039L9.10306 20.9732C8.57981 19.7415 7.35787 18.8755 5.9375 18.8755C4.04206 18.8755 2.5 20.4175 2.5 22.313C2.5 24.2084 4.04206 25.7505 5.9375 25.7505C7.64462 25.7505 9.0645 24.4994 9.32987 22.8661L13.7467 21.4944C14.2601 22.1805 15.0791 22.6255 16 22.6255C16.9209 22.6255 17.7399 22.1805 18.2533 21.4944L22.6701 22.8661Z"
        fill="#0F0F0F"
      />
    </svg>
  ),
  Automated: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.375 29.125H22.3003L21.6753 27.25H10.3247L9.69971 29.125H6.625C6.10693 29.125 5.6875 29.5444 5.6875 30.0625C5.6875 30.5806 6.10693 31 6.625 31H25.375C25.8931 31 26.3125 30.5806 26.3125 30.0625C26.3125 29.5444 25.8931 29.125 25.375 29.125Z"
        fill="#0F0F0F"
      />
      <path
        d="M25.375 6.625C24.8577 6.625 24.4375 7.04517 24.4375 7.5625C24.4375 8.07983 24.8577 8.5 25.375 8.5C25.8923 8.5 26.3125 8.07983 26.3125 7.5625C26.3125 7.04517 25.8923 6.625 25.375 6.625Z"
        fill="#0F0F0F"
      />
      <path
        d="M29.125 1H2.8125C1.26172 1 0 2.26172 0 3.8125V19.75H5.6875V16.9375C5.6875 16.4194 6.10693 16 6.625 16H8.07349C8.17041 15.7273 8.28125 15.4597 8.40674 15.197L7.38208 14.1716C7.01587 13.8054 7.01587 13.2122 7.38208 12.8459L10.0334 10.1946C10.3997 9.82837 10.9929 9.82837 11.3591 10.1946L12.3845 11.22C12.6472 11.0945 12.9146 10.9829 13.1875 10.8857V9.4375C13.1875 8.91943 13.6069 8.5 14.125 8.5H17.875C18.3931 8.5 18.8125 8.91943 18.8125 9.4375V10.886C19.0852 10.9829 19.3528 11.0947 19.6155 11.22L20.6409 10.1946C21.0071 9.82861 21.6003 9.82861 21.9666 10.1946L24.6179 12.8459C24.9841 13.2122 24.9841 13.8057 24.6179 14.1716L23.5933 15.197C23.7188 15.46 23.8296 15.7273 23.9265 16H25.375C25.8931 16 26.3125 16.4194 26.3125 16.9375V19.75H32V3.8125C32 2.26172 30.6758 1 29.125 1ZM25.375 10.375C23.8242 10.375 22.5625 9.11328 22.5625 7.5625C22.5625 6.01172 23.8242 4.75 25.375 4.75C26.9258 4.75 28.1875 6.01172 28.1875 7.5625C28.1875 9.11328 26.9258 10.375 25.375 10.375Z"
        fill="#0F0F0F"
      />
      <path
        d="M13.1875 18.8125C13.1875 19.1365 13.2622 19.449 13.3694 19.75H18.6306C18.7378 19.449 18.8125 19.1365 18.8125 18.8125C18.8125 17.2617 17.5508 16 16 16C14.449 16 13.1875 17.2617 13.1875 18.8125Z"
        fill="#0F0F0F"
      />
      <path
        d="M9.67358 17.1719C9.56665 17.5857 9.19312 17.875 8.76538 17.875H7.5625V19.75H11.4358C11.3728 19.4412 11.3125 19.1309 11.3125 18.8125C11.3125 16.228 13.4155 14.125 16 14.125C18.5845 14.125 20.6875 16.228 20.6875 18.8125C20.6875 19.1309 20.6272 19.4412 20.5642 19.75H24.4375V17.875H23.2346C22.8069 17.875 22.4333 17.5857 22.3264 17.1719C22.177 16.5906 21.9436 16.0283 21.6323 15.501C21.4153 15.1331 21.4749 14.6643 21.7769 14.3621L22.6294 13.5088L21.3037 12.1831L20.4504 13.0364C20.1482 13.3396 19.6785 13.3999 19.3105 13.1802C18.7842 12.8699 18.2229 12.6355 17.6406 12.4861C17.2268 12.3792 16.9375 12.0056 16.9375 11.5779V10.375H15.0625V11.5779C15.0625 12.0056 14.7732 12.3792 14.3594 12.4861C13.7771 12.6355 13.2158 12.8699 12.6895 13.1802C12.3232 13.3999 11.8525 13.3396 11.5496 13.0364L10.6963 12.1831L9.37061 13.5088L10.2231 14.3621C10.5251 14.6643 10.5847 15.1331 10.3677 15.501C10.0564 16.0283 9.823 16.5906 9.67358 17.1719Z"
        fill="#0F0F0F"
      />
      <path
        d="M0 22.5625C0 24.1133 1.26172 25.375 2.8125 25.375H29.125C30.6758 25.375 32 24.1133 32 22.5625V21.625H0V22.5625Z"
        fill="#0F0F0F"
      />
    </svg>
  ),
  Predictive: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_89575)">
        <path
          d="M25.125 26.625C24.0779 26.625 23.1797 27.2722 22.8081 28.1875H20.625V30.0625H22.8081C23.1797 30.9777 24.0779 31.625 25.125 31.625C26.5035 31.625 27.625 30.5035 27.625 29.125C27.625 27.7465 26.5035 26.625 25.125 26.625Z"
          fill="#0F0F0F"
        />
        <path
          d="M29.5 21.3125C29.0891 21.3125 28.7014 21.4128 28.359 21.5892L26.0377 19.6548C25.8692 19.5144 25.6568 19.4375 25.4375 19.4375H20.625V21.3125H25.0981L27.1334 23.0086C27.0474 23.2611 27 23.5312 27 23.8125C27 25.191 28.1215 26.3125 29.5 26.3125C30.8785 26.3125 32 25.191 32 23.8125C32 22.434 30.8785 21.3125 29.5 21.3125Z"
          fill="#0F0F0F"
        />
        <path
          d="M29.5 13.5C28.4529 13.5 27.5547 14.1472 27.1831 15.0625H20.625V16.9375H27.1831C27.5547 17.8527 28.4529 18.5 29.5 18.5C30.8785 18.5 32 17.3785 32 16C32 14.6215 30.8785 13.5 29.5 13.5Z"
          fill="#0F0F0F"
        />
        <path
          d="M26.0377 12.3452L28.359 10.4108C28.7014 10.5873 29.0891 10.6875 29.5 10.6875C30.8785 10.6875 32 9.566 32 8.1875C32 6.809 30.8785 5.6875 29.5 5.6875C28.1215 5.6875 27 6.809 27 8.1875C27 8.46875 27.0474 8.73894 27.1334 8.99137L25.0981 10.6875H20.625V12.5625H25.4375C25.6568 12.5625 25.8692 12.4856 26.0377 12.3452Z"
          fill="#0F0F0F"
        />
        <path
          d="M25.125 5.375C26.5035 5.375 27.625 4.2535 27.625 2.875C27.625 1.4965 26.5035 0.375 25.125 0.375C24.0779 0.375 23.1797 1.02225 22.8081 1.9375H20.625V3.8125H22.8081C23.1797 4.72775 24.0779 5.375 25.125 5.375Z"
          fill="#0F0F0F"
        />
        <path
          d="M9.375 16C9.375 19.6186 12.3189 22.5625 15.9375 22.5625C16.9434 22.5625 17.8971 22.3347 18.75 21.9284V10.0716C17.8971 9.66531 16.9434 9.4375 15.9375 9.4375C12.3189 9.4375 9.375 12.3814 9.375 16Z"
          fill="#0F0F0F"
        />
        <path
          d="M17.8125 0.0625H14.0625C13.5448 0.0625 13.125 0.48225 13.125 1V2.22031C11.3658 2.57869 9.68231 3.27612 8.18275 4.26775L7.31962 3.40469C6.9535 3.03856 6.35994 3.03856 5.99381 3.40469L3.34219 6.05631C2.97606 6.42238 2.97606 7.016 3.34219 7.38212L4.20525 8.24525C3.21362 9.74481 2.51619 11.4283 2.15781 13.1875H0.9375C0.41975 13.1875 0 13.6073 0 14.125V17.875C0 18.3927 0.41975 18.8125 0.9375 18.8125H2.15781C2.51619 20.5717 3.21362 22.2552 4.20525 23.7548L3.34212 24.6179C3.16631 24.7937 3.06756 25.0322 3.06756 25.2808C3.06756 25.5294 3.16631 25.7678 3.34212 25.9436L5.99381 28.5953C6.35994 28.9614 6.9535 28.9614 7.31962 28.5953L8.18275 27.7323C9.68231 28.7239 11.3658 29.4213 13.125 29.7797V31C13.125 31.5177 13.5448 31.9375 14.0625 31.9375H17.8125C18.3302 31.9375 18.75 31.5177 18.75 31V23.9549C17.8699 24.267 16.9233 24.4375 15.9375 24.4375C11.2851 24.4375 7.5 20.6524 7.5 16C7.5 11.3476 11.2851 7.5625 15.9375 7.5625C16.9233 7.5625 17.8699 7.733 18.75 8.04513V1C18.75 0.48225 18.3302 0.0625 17.8125 0.0625Z"
          fill="#0F0F0F"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_89575">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Alternative: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_89587)">
        <path
          d="M11.3125 15.0625H20.6875C21.2058 15.0625 21.625 14.6431 21.625 14.125V13.1875C21.625 10.0857 19.1018 7.5625 16 7.5625C12.8982 7.5625 10.375 10.0857 10.375 13.1875V14.125C10.375 14.6431 10.7944 15.0625 11.3125 15.0625Z"
          fill="#0F0F0F"
        />
        <path
          d="M31.0625 7.5625C29.5061 7.5625 28.1875 8.8186 28.1875 10.375V18.7187C28.1875 18.925 28.0937 19.1311 27.9438 19.2812C27.9438 19.2812 23.0312 24.1938 22.7876 24.4375C22.3938 24.8313 21.8125 24.7937 21.4563 24.4375C21.0998 24.0813 21.0998 23.5 21.4375 23.1438C21.4375 23.1438 26.0127 18.5874 26.0127 18.5688C26.3232 18.2234 26.3589 17.6811 25.9939 17.2749C24.9492 16.2307 23.1328 16.1338 22.0188 17.2749C22.0188 17.2749 18.1001 21.1938 17.9875 21.3064C17.3125 22.1501 16.9375 23.1814 16.9375 24.2688C16.9375 24.6714 16.9375 31.2551 16.9375 31.0625C16.9375 31.5876 17.3499 32 17.875 32H25.375C25.9001 32 26.3125 31.5876 26.3125 31.0625V28.5437C29.9587 23.4231 30.0627 23.2595 31.0061 22.0937C31.6626 21.2688 32 20.2375 32 19.2063V8.5C32 7.97485 31.5876 7.5625 31.0625 7.5625Z"
          fill="#0F0F0F"
        />
        <path
          d="M5.68749 28.5437V31.0625C5.68749 31.5876 6.09984 32 6.62499 32H14.125C14.6501 32 15.0625 31.5876 15.0625 31.0625C15.0625 31.2548 15.0625 24.6714 15.0625 24.2688C15.0625 23.1811 14.6875 22.1501 14.0124 21.3061C13.9001 21.1938 9.98118 17.2749 9.98118 17.2749C8.86717 16.1335 7.05077 16.2307 6.00609 17.2749C5.6411 17.6809 5.67675 18.2234 5.98754 18.5686C5.98754 18.5874 10.5625 23.1438 10.5625 23.1438C10.9001 23.5 10.9001 24.0813 10.5439 24.4375C10.1875 24.7937 9.60643 24.8313 9.21263 24.4375C8.96873 24.1936 4.05639 19.2812 4.05639 19.2812C3.90624 19.1311 3.81249 18.925 3.81249 18.7187V10.375C3.81249 8.8186 2.49389 7.5625 0.937498 7.5625C0.412353 7.5625 0 7.97485 0 8.5V19.2063C0 20.2375 0.337646 21.2688 0.993895 22.0937C1.93725 23.2595 2.04126 23.4231 5.68749 28.5437Z"
          fill="#0F0F0F"
        />
        <path
          d="M16 5.68749C17.5532 5.68749 18.8125 4.36571 18.8125 2.81249C18.8125 1.25927 17.5532 0 16 0C14.4468 0 13.1875 1.25927 13.1875 2.81249C13.1875 4.36571 14.4468 5.68749 16 5.68749Z"
          fill="#0F0F0F"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_89587">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Fraud: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0034 9.90332C12.6414 9.90332 9.90625 12.6384 9.90625 16.0002C9.90625 19.3623 12.6414 22.0974 16.0034 22.0974C19.3652 22.0974 22.1003 19.3623 22.1003 16.0002C22.1003 12.6384 19.3652 9.90332 16.0034 9.90332ZM19.6233 14.852L15.2554 19.2199C15.072 19.4033 14.8315 19.4951 14.5913 19.4951C14.3511 19.4951 14.1108 19.4035 13.9275 19.2199L12.2583 17.5508C11.8916 17.1843 11.8916 16.5898 12.2583 16.2231C12.6247 15.8564 13.2192 15.8564 13.5859 16.2231L14.5913 17.2285L18.2956 13.5244C18.6621 13.1577 19.2566 13.1577 19.6233 13.5244C19.99 13.8909 19.99 14.4853 19.6233 14.852Z"
        fill="#0F0F0F"
      />
      <path
        d="M29.5929 8.68241L29.592 8.65751C29.578 8.35013 29.5688 8.02494 29.5631 7.66313C29.537 5.89873 28.1344 4.43926 26.3698 4.34062C22.6906 4.1353 19.8444 2.9356 17.4125 0.565245L17.3918 0.54547C16.5986 -0.181823 15.4021 -0.181823 14.6086 0.54547L14.5878 0.565245C12.156 2.9356 9.30978 4.1353 5.63059 4.34087C3.8662 4.43926 2.46337 5.89873 2.43724 7.66337C2.43187 8.02274 2.42235 8.34794 2.40844 8.65751L2.40697 8.71537C2.33544 12.4671 2.24657 17.1362 3.80858 21.3743C4.66746 23.7048 5.96824 25.7307 7.67453 27.396C9.61789 29.2925 12.1633 30.7981 15.2399 31.8708C15.34 31.9057 15.444 31.9341 15.55 31.9553C15.6994 31.9851 15.8498 32 16.0002 32C16.1506 32 16.3012 31.9851 16.4504 31.9553C16.5563 31.9341 16.6611 31.9055 16.7617 31.8703C19.8347 30.7956 22.3774 29.2893 24.319 27.3931C26.0246 25.7273 27.3254 23.7009 28.185 21.3699C29.7528 17.1192 29.6642 12.4412 29.5929 8.68241ZM15.9997 23.9753C11.6023 23.9753 8.02488 20.398 8.02488 16.0005C8.02488 11.6031 11.6023 8.02567 15.9997 8.02567C20.3969 8.02567 23.9745 11.6031 23.9745 16.0005C23.9745 20.398 20.3969 23.9753 15.9997 23.9753Z"
        fill="#0F0F0F"
      />
    </svg>
  ),
  Explainable: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_89602)">
        <path
          d="M27.381 17.083H24.9062C25.1585 17.7736 25.2963 18.5189 25.2963 19.2958V28.6489C25.2963 28.9728 25.2399 29.2837 25.1374 29.5728H29.2287C30.757 29.5728 32.0003 28.3294 32.0003 26.8012V21.7023C32.0004 19.1553 29.9281 17.083 27.381 17.083Z"
          fill="#0F0F0F"
        />
        <path
          d="M6.70408 19.2958C6.70408 18.5189 6.84189 17.7736 7.09414 17.083H4.61938C2.07225 17.083 0 19.1553 0 21.7024V26.8012C0 28.3295 1.24331 29.5728 2.77163 29.5728H6.86301C6.76045 29.2836 6.70408 28.9728 6.70408 28.6489V19.2958Z"
          fill="#0F0F0F"
        />
        <path
          d="M18.8317 14.6758H13.1741C10.6269 14.6758 8.55469 16.748 8.55469 19.2952V28.6483C8.55469 29.1585 8.96831 29.5722 9.47856 29.5722H22.5272C23.0375 29.5722 23.4511 29.1586 23.4511 28.6483V19.2952C23.4511 16.748 21.3788 14.6758 18.8317 14.6758Z"
          fill="#0F0F0F"
        />
        <path
          d="M16.0007 2.42773C12.9374 2.42773 10.4453 4.91986 10.4453 7.98318C10.4453 10.061 11.5921 11.8757 13.2858 12.8284C14.0891 13.2803 15.0152 13.5386 16.0007 13.5386C16.9862 13.5386 17.9123 13.2803 18.7156 12.8284C20.4093 11.8757 21.5561 10.0609 21.5561 7.98318C21.5561 4.91993 19.064 2.42773 16.0007 2.42773Z"
          fill="#0F0F0F"
        />
        <path
          d="M6.24845 7.60547C3.9575 7.60547 2.09375 9.46922 2.09375 11.7602C2.09375 14.0511 3.9575 15.9149 6.24845 15.9149C6.82957 15.9149 7.38295 15.7945 7.88564 15.5781C8.75476 15.2039 9.47139 14.5415 9.91483 13.7119C10.2261 13.1295 10.4031 12.4652 10.4031 11.7602C10.4031 9.46928 8.53939 7.60547 6.24845 7.60547Z"
          fill="#0F0F0F"
        />
        <path
          d="M25.7563 7.60547C23.4653 7.60547 21.6016 9.46922 21.6016 11.7602C21.6016 12.4653 21.7786 13.1296 22.0899 13.7119C22.5333 14.5416 23.2499 15.204 24.1191 15.5781C24.6218 15.7945 25.1751 15.9149 25.7563 15.9149C28.0472 15.9149 29.911 14.0511 29.911 11.7602C29.911 9.46922 28.0472 7.60547 25.7563 7.60547Z"
          fill="#0F0F0F"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_89602">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
}

const InWhyChooseSection = () => {
  const { title, subtitle, items } = aiInRecruitingWhyChooseSectionData

  return (
    <section className={styles.whyChooseSection}>
      <div className="container">
        <h2 className={styles.sectionTitle}>{title}</h2>
        <p className={styles.sectionSubtitle}>{subtitle}</p>
        <div className="row g-3 justify-content-center">
          {items.map((item) => (
            <div key={item.iconKey} className="col-12 col-md-6 col-lg-4">
              <div className={styles.card}>
                <div className={styles.iconCircle}>{icons[item.iconKey]}</div>
                <h3 className={styles.cardTitle}>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default InWhyChooseSection
